// web/src/console/sections/LogsSection.tsx
import type { JSX } from "react";
import { useState } from "react";
import { adminApi } from "../../lib/adminApi";
import { useConsole } from "../ConsoleContext";
import { useAsync } from "../useAsync";
import { fmtRelative } from "../format";

const LEVELS = [{ v: undefined, l: "全部" }, { v: 30, l: "Info+" }, { v: 40, l: "Warn+" }, { v: 50, l: "Error+" }];

export function LogsSection(): JSX.Element {
  const { tick } = useConsole();
  const [level, setLevel] = useState<number | undefined>(undefined);
  const [filter, setFilter] = useState("");
  const logs = useAsync(() => adminApi.logs(level), [level, tick]);
  const rel = useAsync(() => adminApi.releases(), []);
  const rows = (logs.data?.logs ?? []).filter((r) => filter === "" || r.msg.toLowerCase().includes(filter.toLowerCase()));
  return (
    <div className="cc-grid cc-grid-2">
      <div className="cc-card" style={{ gridColumn: "1 / -1" }}>
        <div className="cc-topbar" style={{ border: "none", padding: 0, marginBottom: 8 }}>
          <span className="cc-card-title">日志</span><span className="cc-topbar-spacer" />
          {LEVELS.map((x) => <button key={x.l} className={`cc-range${level === x.v ? " active" : ""}`} onClick={() => setLevel(x.v)}>{x.l}</button>)}
          <input className="cc-back" placeholder="筛选…" value={filter} onChange={(e) => setFilter(e.target.value)} />
        </div>
        {logs.loading ? <div className="cc-skeleton" style={{ height: 240 }} /> :
          logs.error ? <div className="cc-empty">加载失败。 <button className="cc-back" onClick={logs.reload}>重试</button></div> :
          rows.length === 0 ? <div className="cc-empty">暂无日志</div> :
          <div style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-caption)" }}>
            {rows.map((r, i) => (
              <div key={i} className="cc-barchart-row" style={{ gridTemplateColumns: "60px 70px 1fr" }}>
                <span style={{ color: r.level >= 50 ? "var(--color-error)" : r.level >= 40 ? "var(--color-warning)" : "var(--text-tertiary)" }}>{r.levelLabel}</span>
                <span>{fmtRelative(r.ts)}</span><span style={{ textAlign: "left" }}>{r.msg}</span>
              </div>
            ))}
          </div>}
      </div>
      <div className="cc-card" style={{ gridColumn: "1 / -1" }}>
        <div className="cc-card-title">版本记录</div>
        {(rel.data?.releases ?? []).map((r, ri) => (
          <div key={`${r.version}-${r.date ?? ri}`} style={{ marginBottom: 8 }}>
            <strong>{r.version}</strong> {r.date && <span style={{ color: "var(--text-tertiary)" }}>· {r.date}</span>}
            <ul style={{ margin: "4px 0 0 16px", color: "var(--text-secondary)" }}>{r.notes.map((n, i) => <li key={i}>{n}</li>)}</ul>
          </div>
        ))}
      </div>
    </div>
  );
}
